/** Normalize both labels and queries for case-insensitive typeahead matching. */
function normalizeTypeaheadText(text) {
    return text.toLocaleLowerCase();
}
/** Extract a case-preserving label, which Select can also use for display. */
function getItemLabel(item) {
    // Count each referenced label only once.
    const referencedLabels = new Set();
    const hiddenElements = new Map();
    // Cache visibility checks for this extraction, including stylesheet-based display: none.
    function isHidden(element) {
        const cached = hiddenElements.get(element);
        if (cached !== undefined)
            return cached;
        const hidden = element.getAttribute('aria-hidden') === 'true' ||
            element.hasAttribute('hidden') ||
            element.ownerDocument.defaultView?.getComputedStyle(element).display === 'none';
        hiddenElements.set(element, hidden);
        return hidden;
    }
    // A referenced label can also be hidden by an ancestor outside its subtree.
    function isHiddenReference(label) {
        for (let element = label; element; element = element.parentElement) {
            if (isHidden(element))
                return true;
        }
        return false;
    }
    function read(node, inLabelledBy = false, includeHidden = false) {
        // Read text directly; ignore comments and other node types.
        if (node.nodeType === Node.TEXT_NODE)
            return node.textContent ?? '';
        if (node.nodeType !== Node.ELEMENT_NODE)
            return '';
        const element = node;
        // Skip hidden subtrees unless an explicit reference allows them.
        if (!includeHidden && isHidden(element))
            return '';
        // aria-labelledby takes precedence, but references cannot be chained.
        const labelledBy = element.getAttribute('aria-labelledby')?.trim();
        if (!inLabelledBy && labelledBy) {
            // Resolve existing labels in the specified order.
            const text = labelledBy
                .split(/\s+/)
                .map((id) => {
                const label = element.ownerDocument.getElementById(id);
                if (!label || referencedLabels.has(label))
                    return '';
                referencedLabels.add(label);
                // Hidden references include their subtree; visible ones still filter hidden children.
                return read(label, true, isHiddenReference(label));
            })
                .join(' ');
            // Use the referenced text if it provides a label.
            if (text.trim())
                return text;
        }
        // Otherwise, prefer a nonempty aria-label over child content.
        const label = element.getAttribute('aria-label');
        if (label?.trim())
            return label;
        // Fall back to nested text, preserving the current reference context.
        return Array.from(node.childNodes, (child) => read(child, inLabelledBy, includeHidden)).join('');
    }
    // Normalize whitespace in the final matching text.
    return read(item).replace(/\s+/g, ' ').trim();
}

export { getItemLabel, normalizeTypeaheadText };
//# sourceMappingURL=typeahead.js.map
